import { gql } from 'graphql-request';

export const listBakery2bClient = gql`
  query ListBakery2b {
    wawiAssist {
      listWA_Bakery2b {
        id
        note
        email
        isDeactivated
        name
        orderAddNewItem
        orderShowPrice
        orderNoDelivery
        standardOrderEdit
        whyDeactivated
      }
    }
  }
`;

export const saveBakery2bClient = gql`
  mutation SaveBakery2bClient($dataToSave: WA_SaveBakery2bClientInput!) {
    wawiAssist {
      saveWA_Bakery2bClient(dataToSave: $dataToSave) {
        status
      }
    }
  }
`;

export const activateBakery2bClient = gql`
  mutation ActivateBakery2bClient($activateWaBakery2BClientId: ID!) {
    wawiAssist {
      activateWA_Bakery2bClient(id: $activateWaBakery2BClientId) {
        status
      }
    }
  }
`;

export const addCustomerConnectedWithBakery2BClient = gql`
  mutation AddCustomerConnectedWithBakery2BClient(
    $customerData: WA_AddCustomerConnectedWithBakery2BClientInput!
  ) {
    wawiAssist {
      addWA_CustomerConnectedWithBakery2BClient(customerData: $customerData) {
        customerId
        customerNo
        name
      }
    }
  }
`;

export const deactivateBakery2bClient = gql`
  mutation DeactivateBakery2bClient($deactivateWaBakery2BClientId: ID!, $whyDeactivated: String!) {
    wawiAssist {
      deactivateWA_Bakery2bClient(
        id: $deactivateWaBakery2BClientId
        whyDeactivated: $whyDeactivated
      ) {
        status
      }
    }
  }
`;

export const deleteBakery2bClient = gql`
  mutation DeleteBakery2bClient($deleteWaBakery2BClientId: ID!) {
    wawiAssist {
      deleteWA_Bakery2bClient(id: $deleteWaBakery2BClientId) {
        status
      }
    }
  }
`;

export const deleteCustomerConnectedWithBakery2BClient = gql`
  mutation DeleteCustomerConnectedWithBakery2BClient(
    $customerData: WA_DeleteCustomerConnectedWithBakery2BClientInput!
  ) {
    wawiAssist {
      deleteWA_CustomerConnectedWithBakery2BClient(customerData: $customerData) {
        status
      }
    }
  }
`;

export const listCustomerConnectedWithBakery2bClient = gql`
  query ListCustomerConnectedWithBakery2bClient($listWaCustomerConnectedWithBakery2BClientId: ID) {
    wawiAssist {
      listWA_CustomerConnectedWithBakery2bClient(id: $listWaCustomerConnectedWithBakery2BClientId) {
        id
        customerNo
        name
      }
    }
  }
`;

export const reinviteBakery2bClient = gql`
  mutation ReinviteBakery2bClient($name: String!, $email: String!) {
    wawiAssist {
      reinviteWA_Bakery2bClient(name: $name, email: $email) {
        status
      }
    }
  }
`;

export const getBakery2bSettings = gql`
  query GetWA_Bakery2bSettings {
    wawiAssist {
      getWA_Bakery2bSettings {
        allowZeroOrders
        brandName
        companyName
        isMultiOrders
        language
        mainCurrency
        menuBgColor
        menuBgImg
        orderFutureDays
        orderMinimalValue
        profileLogo
        showTotalColumn
        site
        useWholeNumbers
      }
      getConfigData {
        isEditUsualOrdersInBakery2b
      }
    }
  }
`;

export const saveBakery2bSettings = gql`
  mutation SaveWA_Bakery2bSettings($params: WA_SaveBakery2bSettings!) {
    wawiAssist {
      saveWA_Bakery2bSettings(params: $params)
    }
  }
`;

export const listBakery2bStatistic = gql`
  query ListBakery2bStatistic($params: WA_Bakery2bStatisticInput!) {
    wawiAssist {
      listWA_Bakery2bStatistic(params: $params) {
        email
        name
        newBakery2bOrders
        orders
        totalOrders
      }
    }
  }
`;
